










import { Vue, Component } from 'vue-property-decorator';
import ContratosSigaBase from './ContratosSigaBase.vue';

@Component({
  components: { ContratosSigaBase },
})
export default class ContratosSigaPantalla extends Vue {}
